// @flow strict
import { string, object } from 'yup';
import axios from 'axios';

const validEmailCheck = async (email: string, sendGridApiKey: string) => {
  if (!email) {
    return false;
  }
  const headers = {
    Authorization: `Bearer ${sendGridApiKey}`,
  };
  try {
    const response = await axios.post(
      'https://api.sendgrid.com/v3/validations/email',
      {
        email,
        source: 'signup',
      },
      { headers },
    );
    return response.data.result.verdict !== 'Invalid';
  } catch {
    // Ignore sendgrid network error.
    return true;
  }
};

const makeCacheableValidationFn = sendGridApiKey => {
  const memo = {};
  return value => {
    if (!sendGridApiKey) {
      return true;
    }
    // $FlowFixMe
    if (memo[value]) {
      return memo[value];
    }
    if (/\S+@\S+\.\S+/i.test(String(value))) {
      // $FlowFixMe
      memo[value] = validEmailCheck(value, sendGridApiKey);
    } else {
      // $FlowFixMe
      memo[value] = true;
    }
    // $FlowFixMe
    return memo[value];
  };
};

export const SignUpSchema = ({
  restrictedEmails,
  restrictedEmailMessage,
  sendGridApiKey,
  noPhone = false,
  isEmailOnly,
}: any) => {
  if (isEmailOnly) {
    // $FlowFixMe
    return object().shape({
      Email: string()
        .trim()
        .email('Invalid email')
        .max(70, 'Your email is too long')
        .test(
          'Invalid Email Domains',
          restrictedEmailMessage,
          value => !restrictedEmails.some(e => (value || '').includes(e)),
        )
        .test('Invalid Email', 'Invalid Email', makeCacheableValidationFn(sendGridApiKey))
        .required('\u00A0'),
    });
  }
  const phone = {
    PhoneNumber: string()
      .max(20, 'Your phone number is too long')
      .required('Enter your phone number'),
  };

  // $FlowFixMe
  return object().shape({
    Firstname: string()
      .trim()
      .max(24, 'Your name is too long')
      .required('Enter your first name'),
    Lastname: string()
      .trim()
      .max(24, 'Your name is too long')
      .required('Enter your last name'),
    Company: string()
      .trim()
      .max(80, 'Company name is too long')
      .required('Enter your company name'),
    Email: string()
      .trim()
      .email('Invalid email')
      .max(70, 'Your email is too long')
      .test(
        'Invalid Email Domains',
        restrictedEmailMessage,
        value => !restrictedEmails.some(e => (value || '').includes(e)),
      )
      .test('Invalid Email', 'Invalid Email', makeCacheableValidationFn(sendGridApiKey))
      .required('Enter your work email'),
    ...(noPhone ? {} : phone),
  });
};
